import { defineMessages } from 'react-intl';

export default defineMessages({
    mortgageValidationMsg: {
        id: 'quoteandbind.contacts.policyroles.Mortgage Position cannot be skipped. Please enter mortgagees in order of first, second, and third',
        defaultMessage: 'Mortgage Position cannot be skipped. Please enter mortgagees in order of first, second, and third.',
    },
    mortgageValidationTitle: {
        id: 'quoteandbind.contacts.policyroles.Invalid Mortgage Positions',
        defaultMessage: 'Invalid Mortgage Positions',
    },
    yesModal: {
        "id": "translation.additionalInformation.Yes",
        "defaultMessage": "Yes"
    },
    noModal: {
        "id": "translation.additionalInformation.No",
        "defaultMessage": "No"
    },
    saveFailedMsg: {
        id: 'quoteandbind.contacts.policyroles.Save failed',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'quoteandbind.contacts.policyroles.Cannot Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },
    cancel: {
        "id": "translation.additionalInformation.Cancel",
        "defaultMessage": "Cancel"
    },
    removeAdditionalInterest: {
        "id": "translation.additionalInformation.Remove Additional Interest",
        "defaultMessage": "Remove Additional Interest"
    },
    removeAddlInterestMessage: {
        "id": "translation.additionalInformation.Are you sure you want to remove this contact?",
        "defaultMessage": "Are you sure you want to remove this contact?"
    },
    contractofSale: {
        "id": "translation.additionalInformation.Contract of Sale",
        "defaultMessage": "Contract of Sale"
    },
    mortgagee: {
        "id": "translation.additionalInformation.Mortgagee",
        "defaultMessage": "Mortgagee"
    },
    lossPayee: {
        "id": "translation.additionalInformation.Loss Payee",
        "defaultMessage": "Loss Payee"
    },
    premiumFinance: {
        "id": "translation.additionalInformation.Premium Finance",
        "defaultMessage": "Premium Finance"
    },
    firstMortgagee: {
        "id": "translation.additionalInformation.First Mortgage",
        "defaultMessage": "First Mortgage"
    },
    secondMortgagee: {
        "id": "translation.additionalInformation.Second Mortgage",
        "defaultMessage": "Second Mortgage"
    },
    thirdMortgagee: {
        "id": "translation.additionalInformation.Third Mortgage",
        "defaultMessage": "Third Mortgage"
    },
    close: {
        "id": "quoteandbind.residential.additionalInsured.Close",
        "defaultMessage": "Close"
    },
});
